import PropTypes from 'prop-types';
import React from 'react';
import { useLocale } from 'next-intl';

import StyledEventDate from './eventDate.style';
import { LongArrowRight } from '../../icons/arrow/arrow';

const EventShape = () => (
  <svg
    role="img"
    aria-hidden="true"
    focusable="false"
    width="164"
    height="164"
    viewBox="0 0 164 164"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 35.855v120.926S2 162 6.625 162h150.75s4.625 0 4.625-5.22V7.219S162 2 157.375 2H37.43C36.543 2 2 35.105 2 35.855z"
      stroke="#000"
      strokeWidth="3"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

const EventDate = props => {
  const locale = useLocale();
  const {
    startDate,
    endDate,
    period,
    isTeaser = false,
    showWeekday = false,
    timeOnTop = false,
    hasTime = false
  } = props;

  const month = {
    de: {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mär',
      '04': 'Apr',
      '05': 'Mai',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sept',
      10: 'Okt',
      11: 'Nov',
      12: 'Dez'
    },
    en: {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sept',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    }
  };

  return (
    <StyledEventDate {...props} isTeaser={isTeaser} timeOnTop={timeOnTop} period={period}>
      <time
        className="eventDate__startdate"
        dateTime={`${startDate.Y ? `${startDate.Y}-` : ''}${startDate.m}-${startDate.d}`}
      >
        <div className="eventDate__shape-wrapper" aria-hidden="true">
          <div className="eventDate__shape">
            <EventShape />
          </div>
        </div>
        {showWeekday && <span className="eventDate__year">{startDate.w}</span>}
        <span className="eventDate__day">
          {startDate.d}
          {locale !== 'en' && '.'}
        </span>
        <span className="eventDate__month">{month[locale][startDate.m]}</span>
        <span className="eventDate__year">{startDate.Y}</span>
      </time>

      {/* When its a period event show endDate */}
      {period && (
        <time
          className="eventDate__enddate"
          dateTime={`${endDate.d}-${endDate.m}${endDate.Y ? `-${endDate.Y}` : ''}`}
        >
          <div className="eventDate__shape-wrapper" aria-hidden="true">
            <div className="eventDate__shape">
              <EventShape />
            </div>
          </div>
          <span className="eventDate__day">
            {endDate.d}
            {locale !== 'en' && '.'}
          </span>
          <span className="eventDate__month">{month[locale][endDate.m]}</span>
          <span className="eventDate__year">{endDate.Y}</span>
        </time>
      )}
      {!showWeekday && hasTime && (
        <div className="eventDate__arrow-wrapper">
          <div className="eventDate__arrow">
            <LongArrowRight role="presentation" />
          </div>
        </div>
      )}
    </StyledEventDate>
  );
};

EventDate.propTypes = {
  isTeaser: PropTypes.bool,
  showWeekday: PropTypes.bool,
  isBig: PropTypes.bool,
  isSmall: PropTypes.bool,
  hasTime: PropTypes.bool,
  timeOnTop: PropTypes.bool,
  period: PropTypes.bool.isRequired,
  startDate: PropTypes.shape({
    w: PropTypes.string,
    d: PropTypes.string,
    m: PropTypes.string,
    Y: PropTypes.string
  }).isRequired,
  endDate: PropTypes.shape({
    d: PropTypes.string,
    m: PropTypes.string,
    Y: PropTypes.string
  }).isRequired
};

export default EventDate;
